/* CBC — correctifs et interactions de la colonne de gauche des PDP.

   1. srcset : l'image principale des buy box est rendue avec `srcset` + `sizes`. Le navigateur
      choisit alors sa source dans le srcset et IGNORE `src` : les scripts de section qui font
      `main.src = ...` modifient le DOM sans rien changer à l'écran. On retire srcset/sizes.
   2. Préchargement des grandes images, une à la fois, quand le navigateur est libre.
   3. Flèches précédent / suivant sur l'image principale.
   4. Flèches haut / bas sur la colonne de vignettes.
   5. Badge d'accroche visible uniquement sur la première image.
   6. Carrousel d'avis : chevrons, défilement auto et balayage.

   Performance (v2) : aucune mesure de mise en page (scrollHeight, clientWidth…) juste après une
   écriture dans le DOM. Toutes les écritures se font d'abord ; les mesures sont regroupées dans
   UNE seule image d'animation (requestAnimationFrame), et les tailles sont suivies par
   ResizeObserver, qui les fournit sans forcer de recalcul. Supprime les « forced reflows ». */
(function () {
  "use strict";

  var PATH_LEFT = "M15 6l-6 6l6 6";
  var PATH_RIGHT = "M9 6l6 6l-6 6";
  var PATH_UP = "M6 15l6 -6l6 6";
  var PATH_DOWN = "M6 9l6 6l6 -6";
  var REVIEW_DELAY = 5000;

  /* File de mesures : exécutées ensemble à la prochaine image, après toutes les écritures. */
  var readQueue = [], rafPending = false;
  function measure(fn) {
    readQueue.push(fn);
    if (rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(function () {
      rafPending = false;
      var q = readQueue; readQueue = [];
      /* Lire tout, puis appliquer tout : chaque fonction renvoie éventuellement une écriture. */
      var writes = q.map(function (f) { return f(); });
      writes.forEach(function (w) { if (typeof w === "function") w(); });
    });
  }

  function scopeOf(root) { return root && root.querySelectorAll ? root : document; }

  function stripSrcset(root) {
    var imgs = scopeOf(root).querySelectorAll("img[data-main]");
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].hasAttribute("srcset")) imgs[i].removeAttribute("srcset");
      if (imgs[i].hasAttribute("sizes")) imgs[i].removeAttribute("sizes");
    }
  }

  function thumbsOf(gal) { return Array.prototype.slice.call(gal.querySelectorAll("[data-thumb]")); }
  function largeSrc(src) { return src.replace(/width=\d+/, "width=1200"); }

  function preload(gal) {
    if (gal.getAttribute("data-cbc-pre")) return;
    gal.setAttribute("data-cbc-pre", "1");
    var list = thumbsOf(gal), i = 0;
    function next() {
      if (i >= list.length) return;
      var img = new Image();
      img.decoding = "async";
      img.src = largeSrc(list[i++].src);
      if (img.decode) img.decode().then(next, next); else { img.onload = next; img.onerror = next; }
    }
    next();
  }
  function schedulePreload(gal) {
    var run = function () { preload(gal); };
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 3000 });
    else window.setTimeout(run, 1200);
  }

  /* Écriture pure : aucune lecture de géométrie. */
  function syncKicker(gal) {
    var kicker = gal.querySelector(".gal-main .kicker");
    if (!kicker) return;
    var list = thumbsOf(gal);
    if (list.length < 2) return;
    var active = 0;
    for (var i = 0; i < list.length; i++) if (list[i].hasAttribute("data-active")) { active = i; break; }
    kicker.style.display = active === 0 ? "" : "none";
  }

  function makeButton(cls, flag, path, size, label) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = cls;
    if (flag) b.setAttribute(flag, "");
    b.setAttribute("aria-label", label);
    b.innerHTML = '<svg viewBox="0 0 24 24" width="' + size + '" height="' + size + '" fill="none"' +
      ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"' +
      ' aria-hidden="true"><path d="' + path + '"/></svg>';
    return b;
  }

  function addImageNav(gal) {
    if (gal.getAttribute("data-cbc-nav")) return;
    var main = gal.querySelector(".gal-main");
    if (!main || thumbsOf(gal).length < 2) return;
    gal.setAttribute("data-cbc-nav", "1");

    function step(delta) {
      var list = thumbsOf(gal);
      if (list.length < 2) return;
      var i = 0;
      for (var k = 0; k < list.length; k++) if (list[k].hasAttribute("data-active")) i = k;
      var n = (i + delta + list.length) % list.length;
      list[n].click();
      if (list[n].scrollIntoView) list[n].scrollIntoView({ block: "nearest", inline: "nearest" });
      syncKicker(gal);
    }
    var prev = makeButton("gal-nav", "data-prev", PATH_LEFT, 15, "Image pr\u00e9c\u00e9dente");
    var next = makeButton("gal-nav", "data-next", PATH_RIGHT, 15, "Image suivante");
    prev.addEventListener("click", function (e) { e.preventDefault(); step(-1); });
    next.addEventListener("click", function (e) { e.preventDefault(); step(1); });
    main.appendChild(prev);
    main.appendChild(next);

    gal.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest || !e.target.closest("[data-thumb], .thumb")) return;
      window.setTimeout(function () { syncKicker(gal); }, 0);
    });
  }

  function addThumbScroller(gal) {
    if (gal.getAttribute("data-cbc-thumbnav")) return;
    var strip = gal.querySelector(".gal-thumbs");
    if (!strip || thumbsOf(gal).length < 2) return;
    gal.setAttribute("data-cbc-thumbnav", "1");

    var up = makeButton("gal-thumbnav", "data-thumbs-up", PATH_UP, 14, "Vignettes pr\u00e9c\u00e9dentes");
    var down = makeButton("gal-thumbnav", "data-thumbs-down", PATH_DOWN, 14, "Vignettes suivantes");
    up.hidden = down.hidden = true;
    gal.appendChild(up);
    gal.appendChild(down);

    var clientH = 0;
    /* Mesure groupée ; l'écriture (hidden) est appliquée après toutes les lectures. */
    function sync() {
      measure(function () {
        var max = strip.scrollHeight - strip.clientHeight, top = strip.scrollTop;
        clientH = strip.clientHeight;
        return function () {
          var scrollable = max > 2;
          up.hidden = !scrollable || top <= 2;
          down.hidden = !scrollable || top >= max - 2;
        };
      });
    }
    function page(dir) {
      var amount = Math.max(86, Math.round(clientH * 0.8));
      if (strip.scrollBy) strip.scrollBy({ top: dir * amount, behavior: "smooth" });
      else strip.scrollTop += dir * amount;
    }
    up.addEventListener("click", function (e) { e.preventDefault(); page(-1); });
    down.addEventListener("click", function (e) { e.preventDefault(); page(1); });
    strip.addEventListener("scroll", sync, { passive: true });
    if ("ResizeObserver" in window) new ResizeObserver(sync).observe(strip);
    else window.addEventListener("resize", sync);
    window.addEventListener("load", sync);
    sync();
  }

  function addReviewCarousel(host) {
    if (host.getAttribute("data-cbc-rev")) return;
    var track = host.querySelector(".hr-track");
    if (!track) return;
    var slides = track.querySelectorAll(".hr-slide");
    if (slides.length < 2) return;
    host.setAttribute("data-cbc-rev", "1");

    var idx = 0, paused = false, width = 0;
    /* Largeur suivie par ResizeObserver : jamais lue au moment d'écrire le défilement. */
    if ("ResizeObserver" in window) {
      new ResizeObserver(function (en) { width = en[0].contentRect.width; }).observe(track);
    } else {
      measure(function () { width = track.clientWidth; });
    }
    function goTo(n) {
      idx = (n + slides.length) % slides.length;
      if (!width) return;
      if (track.scrollTo) track.scrollTo({ left: idx * width, behavior: "smooth" });
      else track.scrollLeft = idx * width;
    }
    track.addEventListener("scroll", function () {
      if (width) idx = Math.round(track.scrollLeft / width);
    }, { passive: true });

    var prev = makeButton("hr-prev", null, PATH_LEFT, 14, "Avis pr\u00e9c\u00e9dent");
    var next = makeButton("hr-next", null, PATH_RIGHT, 14, "Avis suivant");
    prev.addEventListener("click", function (e) { e.preventDefault(); goTo(idx - 1); });
    next.addEventListener("click", function (e) { e.preventDefault(); goTo(idx + 1); });
    host.appendChild(prev);
    host.appendChild(next);

    host.addEventListener("pointerenter", function () { paused = true; });
    host.addEventListener("pointerleave", function () { paused = false; });
    host.addEventListener("touchstart", function () { paused = true; }, { passive: true });
    host.addEventListener("touchend", function () { window.setTimeout(function () { paused = false; }, 6000); }, { passive: true });

    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduced) window.setInterval(function () { if (!paused && !document.hidden) goTo(idx + 1); }, REVIEW_DELAY);
  }

  function init(root) {
    stripSrcset(root);
    var scope = scopeOf(root);
    var gals = scope.querySelectorAll(".gal");
    for (var i = 0; i < gals.length; i++) {
      addImageNav(gals[i]);
      addThumbScroller(gals[i]);
      syncKicker(gals[i]);
      schedulePreload(gals[i]);
    }
    var revs = scope.querySelectorAll("[data-review-carousel]");
    for (var j = 0; j < revs.length; j++) addReviewCarousel(revs[j]);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
